export default __webpack_public_path__ + "static/media/Head_3_Ear_1_C4.9d33228a.svg";